export function secondsToMillis(seconds: number): number {
  return seconds * 1000;
}
